import React from 'react';
import RevenueSourceForm from '../components/RevenueSourceForm';

const RevenueSourceManagement = () => {
  return (
    <RevenueSourceForm />
  );
};

export default RevenueSourceManagement; 
